module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n          Add Client\n        ")]), _vm._v(" "), _c('v-card-text', [_c('dfs-client-add-form', {
    on: {
      "namechanged": _vm.onNameChanged
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b793d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/AddClientButton.vue
// module id = 951
// module chunks = 1